<template>
  <div class="push-set">
    <!-- <div class="top">
      <Header moduleTitle="预配舱单-上海">
        <template slot="searchBox">
          <Search></Search>
        </template>
      </Header>
    </div> -->
    <div class="push-content">
      <div class="button-oper-box">
        <!-- <el-button style="width:80px">返回</el-button> -->
        <el-button type="primary" style="width:88px;margin-left:16px">保存设置</el-button>
      </div>
      <div class="page-module-title" style="font-size:18px;padding-top: 24px;">
        推送设置
        <el-tooltip class="item" effect="light" content="" placement="top">
          <img src="../../assets/cps2/wenhao.png" class="tip-icon">
          <div slot="content" style="width:300px">
            <p>1. 保存后，该设置适用于后续的舱单回执的推送，但不会对已经收到的舱单回执进行推送。</p>
            <p>2. 微信/邮箱回执推送可能存在延迟，一切信息以网页端展示为准。</p>
          </div>
        </el-tooltip>
      </div>
      <div>
        <el-checkbox v-model="checked">原始报文回执成功</el-checkbox>
        <el-checkbox v-model="checked">修改报文回执成功</el-checkbox>
        <el-checkbox v-model="checked">删除报文回执成功</el-checkbox>
        <!-- <el-checkbox v-model="checked">重发报文回执成功</el-checkbox> -->
        <el-checkbox v-model="checked">原始报文回执失败</el-checkbox>
        <el-checkbox v-model="checked">修改报文回执失败</el-checkbox>
        <el-checkbox v-model="checked">删除报文回执失败</el-checkbox>
        <!-- <el-checkbox v-model="checked">重发报文回执失败</el-checkbox> -->
      </div>
      <div class="page-module-title" style="margin-top:40px">接收范围</div>
      <div>
        <el-radio v-model="checked" label="1">只接收个人报告发送的数据回执</el-radio>
        <el-radio v-model="checked" label="2">接收同企业下所有通知发送的数据回执</el-radio>
      </div>
      <div class="page-module-title" style="margin-top:40px">接收方式</div>
      <div>
        <el-checkbox v-model="checked" style="display:block;margin-bottom:16px">微信公众号
          <el-tooltip class="item" effect="light" content="" placement="top">
            <img src="../../assets/cps2/wenhao.png" class="tip-icon" style="position:relative;top:1px">
            <div slot="content" style="width:210px;text-align:center">
              <img src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/qr_code.png" style="width:189px">
              <p>e航无忧公众号一定要关注哦！</p>
            </div>
          </el-tooltip>
        </el-checkbox>
        <el-checkbox v-model="checked">邮箱
          <el-tooltip class="item" effect="light" content="" placement="top">
            <img src="../../assets/cps2/wenhao.png" class="tip-icon" style="position:relative;top:1px">
            <div slot="content" style="width:300px">
              请将我们的自动推送邮箱地址 cd@cargofish.cn 添加到白名单以确保正常接收邮件推送哦！
            </div>
          </el-tooltip>
        </el-checkbox>
      </div>
      <div class="email-box">
        <div class="email-item" v-for="(item,index) in emailList" :key="index">
          <el-input v-model="emailList[index].value" placeholder="请输入邮箱地址"></el-input>
          <i class="iconfont icon-zengjia" v-if="emailList.length<5" @click="addEmail(index)"></i>
          <i class="iconfont icon-jianshao" v-if="emailList.length>1" @click="minusEmail(index)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/cps2/Header"
export default {
  name: "PushSet",
  components: { 
    Header
  },
  data(){
    return {
      checked:true,
      emailList:[{
        value:''
      }]
    }
  },
  methods:{
    addEmail(index){
      this.emailList.splice(index+1,0,{value:''})
    },
    minusEmail(index){
      this.emailList.splice(index,1)
    }
  }
};
</script>
<style scoped lang="less">
.push-set {
  font-size: 14px;
  color: #333333;
  height: 100%;
  .push-content {
    background: #ffffff;
    border-radius: 4px;
    padding: 0 24px;
    position: relative;
    height: 100%;
  }
  /deep/.el-checkbox {
    margin-right: 24px;
    .el-checkbox__input {
      line-height: 1.5;
    }
  }
  /deep/.el-radio {
    margin-right: 24px;
    .el-radio__input {
      line-height: 1.5;
    }
  }
  .button-oper-box {
    position: absolute;
    top: 24px;
    right: 24px;
  }
  .el-button {
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  .tip-icon {
    height: 12px;
    width: 12px;
  }
  .email-box {
    .email-item {
      margin-top: 16px;
      i {
        font-size: 18px;
        margin-left: 16px !important;
        color: #1170eb;
        cursor: pointer;
      }
    }
    .el-input {
      width: 240px;
    }
    /deep/.el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
